export default "__VITE_ASSET__5ee25837__"